import { render } from "./SearchIconComponent.vue?vue&type=template&id=95fab962"
const script = {}

import exportComponent from "/home/csoetaert/projects/adct-client-companion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__